import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  IRecurringPaymentCardsRequest,
  IRecurringPaymentCardsResponse,
  IDeleteStoredCardRequest,
} from './recurring-payment.interface';

@Injectable({
  providedIn: 'root',
})
export class RecurringPaymentService {
  private readonly cardsUrl = '/api/v2/checkout/recurring-payment/cards';
  private readonly deleteCardUrl =
    '/api/v2/checkout/recurring-payment/deleteStoredCard';

  constructor(protected http: HttpClient) {}

  getCards(
    request: IRecurringPaymentCardsRequest,
  ): Observable<IRecurringPaymentCardsResponse> {
    return this.http
      .post<IRecurringPaymentCardsResponse>(this.cardsUrl, request)
      .pipe(
        map((response) => {
          if (!response['message']) {
            return response;
          } else {
            throw new HttpErrorResponse({
              error: response,
              url: this.cardsUrl,
            });
          }
        }),
      );
  }

  deleteStoredCard(
    request: IDeleteStoredCardRequest,
  ): Observable<IRecurringPaymentCardsResponse> {
    return this.http
      .post<IRecurringPaymentCardsResponse>(this.deleteCardUrl, request)
      .pipe(
        map((response) => {
          if (!response['message']) {
            return response;
          } else {
            throw new HttpErrorResponse({
              error: response,
              url: this.deleteCardUrl,
            });
          }
        }),
      );
  }
}
